import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';

import Introduction from './Introduction';
import Navigation from './Navigation';
import Criterion from './Criterion';
import ContactMe from './ContactMe';
import About from './About';

import './index.css';

class LandingPage extends Component {
  render() {
    const { strings, history } = this.props;

    return (
      <div>
        <Introduction {...strings} history={history} />
        <Navigation {...strings} />
        <Criterion {...strings} />
        <About {...strings} />
        <Container text>
          <ContactMe {...strings} />
        </Container>
      </div>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/LandingPage/index.js